import { giphyBlack } from '@giphy/js-brand'
import React, { createContext, useState } from 'react'
import styled from 'styled-components'
import Nav from '../../components/nav'
import MenuState from '../../containers/menu'
import GIPHY from './giphy'
import Logo from './logo'

const margin = 6

const containerPadding = `${margin * 2}px 0 ${margin}px ${margin}px;`

const Container = styled.div`
    position: relative;
    z-index: 1001;
    padding: ${containerPadding};
    background: ${giphyBlack};
`

const HeaderContainer = styled.div`
    display: flex;
    align-items: center;
`
const GiphyContainer = styled.div`
    display: flex;
    width: 100%;
`

type MenuState = undefined | 'user' | 'logged out user' | 'category'
type HeaderContextProps = {
    menu: MenuState
    setMenuState: (menu: MenuState) => void
    setIsSearchVisible: (visible: boolean) => void
    isSearchVisible: boolean
}
export const HeaderContext = createContext({} as HeaderContextProps)

const Header = () => {
    const [menu, setMenuState] = useState<MenuState>(undefined)
    const [isSearchVisible, setIsSearchVisible] = useState(false)
    return (
        <Container>
            <HeaderContext.Provider
                value={{
                    menu,
                    setMenuState,
                    isSearchVisible,
                    setIsSearchVisible,
                }}
            >
                <HeaderContainer>
                    <GiphyContainer>
                        <Logo />
                        <GIPHY />
                    </GiphyContainer>
                    <Nav />
                </HeaderContainer>
                <MenuState />
            </HeaderContext.Provider>
        </Container>
    )
}

export default Header
